import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';


import { ScrollPanel } from 'primereact/scrollpanel';
import servicioCruces from '../servicios/ServicioCruces';

import servicioPaginacion from '../servicios/ServicioPaginacion';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';

class RecuperaNru extends Component {
    constructor(){
        super();
        this.state = {
          mostrarModalNru:false,
            cruces:{},
            paginacion: {
                registrosPorPagina: 20,
                clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TwCruces',
                join: ['twCfdi'],
                conjunciones: {}
              },
              first: 0
        }
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this,true);
    
      }

      buscarNru = () => {
        let { paginacion, cruces  } = this.state;
        
        
          let nombrePropiedad = "nru";
          paginacion.conjunciones = {};
          paginacion.conjunciones[nombrePropiedad] = cruces.nru;
          this.setState({ paginacion: paginacion });
          this.obtenerResultados();
        
      }
      obtenerResultados = () => {
        const { paginacion } = this.state;
        servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
          this.setState({ paginacion: response.data });
        });
      }
      actionOpciones = (rowData, column) => {
        return <div>
          
          <Button type="button" icon="pi pi-pencil" className="p-button-success"
             onClick={(e) => this.onBorrar(column.rowIndex, rowData)}  value={rowData.id} name="id" tooltip="Liberar" >
          </Button>
        </div>;
      }
      onBorrar = (fila, datos) => {
        const { cruces } =this.state;
        servicioCruces.vigenciaNru({ id: datos.id,twCfdi:datos.twCfdi }).then(response => {
        cruces.estado = response.data;
        this.setState({ mostrarModalNru: true });
         // this.obtenerResultados();
        }).catch(error => {
          this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Existe un error con la conexion al servidor' });
        })
      }
      cerrarModal = () =>{
        this.setState({ mostrarModalNru: false });
      }
    render(){
        const { cruces ,paginacion,first} = this.state;
        return(
            <div className="card card-w-title">
            <Growl ref={(el) => this.growl = el} />
            <h1>RecuperaNru</h1>
            
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>NRU:</h4>
                <InputText id="nru" name="cruces.nru" value={cruces.nru || ''} onChange={this.asignarValoresObjeto}  />
               
              </div>
              <div className="p-col-12 p-md-4">
                <br /> <br /> <br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarNru} />
              </div>
    
            </div>
    
            <Card>
              <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} scrollHeight="220px"  >
                <Column field="nru" header="Nru" style={{ width: '200px' }} filter={false} autoLayout={true} />
                <Column field="estado" header="Estado" style={{ width: '200px' }} filter={false} autoLayout={true} />
                <Column header="Opciones" body={this.actionOpciones} style={{ textAlign: 'center', width: '12em' }} />
              </DataTable>
              <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={first} onPageChange={this.onPage} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
            </Card>
    

            <Dialog header="Consultar Nru" visible={this.state.mostrarModalNru} style={{ width: '45vw' }} onHide={(e) => this.setState({ mostrarModalNru: false })} maximizable>
          <ScrollPanel style={{ width: '100%', height: '130px' }}>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-12">
                <h4>EL tiempo del Nru es de {cruces.estado} minutos desde que fue capturado.</h4>
                
              </div>
              </div>
               <br />
            <div className="p-grid" style={{ width: "100%" }}>
              <div className="p-col"></div>
              <div className="p-col"></div>
              <div className="p-col ">
                <Button label="Aceptar" onClick={this.cerrarModal}  icon="pi pi-check" />
              </div>
              
            </div>
          </ScrollPanel>
        </Dialog>
          </div>
        );
    }
}
export default RecuperaNru;